export default __webpack_public_path__ + "static/pull_station_b.0f25c1a039babcb1b41a7fb00b4643eb.png";